<template>
  <div
    :id="groupId"
    class="kw-group"
    :class="{'kw-group--open': open}"
  >
    <button
      type="button"
      class="kw-group__h"
      :class="{'kw-group__h--blue': blue}"
      :aria-expanded="open ? 'true' : 'false'"
      @click="$emit('toggle')"
    >
      <v-icon class="kw-group__chev">
        expand_more
      </v-icon>
      <span class="kw-group__copy">
        <span class="kw-group__title-row">
          <span
            v-if="number"
            class="kw-group__num"
            :class="{'kw-group__num--live': live}"
          >{{ number }}</span>
          <span class="kw-group__title">{{ title }}</span>
        </span>
        <span
          v-if="subtitle"
          class="kw-group__sub"
        >{{ subtitle }}</span>
      </span>
      <span
        v-if="countLabel"
        class="kw-group__count"
      >{{ countLabel }}</span>
    </button>
    <div
      v-show="open"
      class="kw-group__body"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: 'KeywordWorkspaceGroup',
        props: {
            groupId: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                required: true
            },
            subtitle: {
                type: String,
                default: ''
            },
            countLabel: {
                type: String,
                default: ''
            },
            number: {
                type: [String, Number],
                default: ''
            },
            open: {
                type: Boolean,
                default: false
            },
            blue: {
                type: Boolean,
                default: false
            },
            live: {
                type: Boolean,
                default: false
            }
        }
    });
</script>

<style scoped lang="sass">
.kw-group
    background: var(--v-surface-base)
    border: 1px solid rgba(58, 53, 65, .10)
    border-radius: 12px
    overflow: hidden
    margin-bottom: 10px

.kw-group__h
    width: 100%
    display: flex
    align-items: center
    gap: 8px
    text-align: left
    border: 0
    cursor: pointer
    padding: 10px 12px
    background: var(--v-surface-base)
    color: inherit

.kw-group__h--blue
    background: linear-gradient(120deg, #0c98f5 0%, #0566c3 100%)
    color: #fff

.kw-group__chev
    opacity: .85
    transition: transform .15s ease

.kw-group--open .kw-group__chev
    transform: rotate(180deg)

.kw-group__copy
    min-width: 0
    flex: 1

.kw-group__title-row
    display: flex
    align-items: center
    gap: 6px

.kw-group__title
    font-size: 13px
    font-weight: 800

.kw-group__sub
    display: block
    font-size: 11px
    font-weight: 400
    opacity: .88
    margin-top: 1px
    text-transform: none
    letter-spacing: 0

.kw-group__count
    margin-left: auto
    font-size: 11px
    font-weight: 700
    white-space: nowrap
    background: var(--v-blockSurface-base)
    color: #445
    padding: 3px 8px
    border-radius: 999px

.kw-group__h--blue .kw-group__count
    background: rgba(255, 255, 255, .16)
    color: #fff

.kw-group__num
    width: 18px
    height: 18px
    border-radius: 50%
    background: #0887dc
    color: #fff
    display: inline-flex
    align-items: center
    justify-content: center
    font-size: 10px
    font-weight: 800
    flex: 0 0 18px

.kw-group__num--live
    background: #6eaa34

.theme--dark
    .kw-group
        border-color: rgba(255, 255, 255, .12)

    .kw-group__h:not(.kw-group__h--blue) .kw-group__count
        color: #c5cbe0
</style>
